import { ArrowLeft, History } from "lucide-react";
import { AppState } from "../types/state";
import { ConfigScreen } from "./ConfigScreen";
import { AppConfig } from "../types/state";

interface Props {
  state: AppState;
  onClose: () => void;
  onUpdateConfig: (config: AppConfig) => Promise<void>;
}

export function SettingsPanel({ state, onClose, onUpdateConfig }: Props) {
  const saveConfig = async (config: AppConfig) => {
    await onUpdateConfig(config);
    onClose();
  };

  return (
    <div className="h-full overflow-y-auto bg-stone-50">
      <div className="flex items-center gap-2 px-3 py-2 border-b border-stone-200 bg-white sticky top-0">
        <button onClick={onClose} className="p-1 hover:bg-stone-100 rounded" aria-label="Retour">
          <ArrowLeft className="w-4 h-4 text-stone-700" />
        </button>
        <h1 className="font-serif-title text-base text-stone-800">Paramètres</h1>
      </div>

      <ConfigScreen
        initial={state.config}
        onCancel={onClose}
        onValidate={async (config) => saveConfig(config)}
        submitLabel="Enregistrer"
        title="Configuration"
      />

      <div className="px-4 pb-6 space-y-2">
        <div className="flex items-center gap-1 text-xs text-stone-500 mt-3">
          <History className="w-3 h-3" /> Historique des versions ({state.versions.length})
        </div>
        <div className="space-y-1">
          {state.versions
            .slice()
            .reverse()
            .map((v) => (
              <div
                key={v.id}
                className="border border-stone-200 bg-white rounded px-2 py-1.5 text-xs"
              >
                <div className="text-stone-800">{v.label}</div>
                <div className="text-stone-500">
                  {new Date(v.savedAt).toLocaleString("fr-FR")} · {v.rows.length} ligne
                  {v.rows.length > 1 ? "s" : ""}
                </div>
              </div>
            ))}
          {state.versions.length === 0 && (
            <div className="text-xs text-stone-500">Aucune version encore sauvegardée.</div>
          )}
        </div>
      </div>
    </div>
  );
}
